import { render, staticRenderFns } from "./StandardPopupBox.vue?vue&type=template&id=fa01980c&scoped=true&"
import script from "./StandardPopupBox.vue?vue&type=script&lang=js&"
export * from "./StandardPopupBox.vue?vue&type=script&lang=js&"
import style0 from "./StandardPopupBox.vue?vue&type=style&index=0&id=fa01980c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa01980c",
  null
  
)

export default component.exports